import Account from '@advisor/models/store/account';
// eslint-disable-next-line import/no-cycle
import Portfolio from '@advisor/models/Portfolio';
import exceptionHandler from '@advisor/util/exceptionHandler';
import RwClientService from '@advisor/rwSdk/ClientService';

const stateObj = function () {
  return new Account();
};

const getters = {};

const actions = {
  async isAccountTradeable(context, payload) {
    try {
      const response = await RwClientService.getAccountTradeStatus(payload);

      return response?.accountStatus;
    } catch (error) {
      exceptionHandler.handleGenericException('account.isAccountTradeableStatus', error);

      return Promise.reject(error);
    }
  },
};

const mutations = {
  SET_CURRENT_PORTFOLIO(state, payload) {
    state.currentPortfolio = new Portfolio(payload[0]);
  },
  SET_TARGET_PORTFOLIO(state, payload) {
    state.targetPortfolio = new Portfolio(payload[0]);
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
